/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LatestAfterPartitionValue } from './latestAfterPartitionValue';
import { LatestBeforePartitionValue } from './latestBeforePartitionValue';
import { PartitionValueRange } from './partitionValueRange';


export interface PartitionValueFilter { 
    /**
     * The Partition Key for a Business Object Data. This must be they Partition Key specified in the Business Object Format. Required                   when partitionValueFilters is present                
     */
    partitionKey?: string;
    /**
     * This specifies a list of partition values. Required when partitionValueRange, latestBeforePartitionValue, or                   latestAfterPartitionValue is not present                
     */
    partitionValues?: Array<string>;
    partitionValueRange?: PartitionValueRange;
    latestBeforePartitionValue?: LatestBeforePartitionValue;
    latestAfterPartitionValue?: LatestAfterPartitionValue;
}
